import React from 'react';
import { useSectionData } from '../hooks/dataContext';
import { format } from 'date-fns';
import { ErrorMessageInfo } from './config';

export function frameSchema(info: any[], preFix: string) {
  return info.map(info => {
    let validationMessages: any = [];
    let validation: string = '';
    switch (info.type) {
      case 'email':
        validation = 'string';
        validationMessages = [
          info.required && {
            type: 'required',
            params: `${info.label} is Required`,
          },
          {
            type: 'email',
            params: 'Please Enter a Valid Email',
          },
        ];
        break;
      case 'date':
        validation = 'date';
        validationMessages = [
          info.required && {
            type: 'required',
            params: `${info.label} is Required`,
          },
        ];
        break;
      case 'password':
        validation = 'string';
        validationMessages = [
          info.required && {
            type: 'required',
            params: `${info.label} is Required`,
          },
          {
            field: 'Password',
            type: 'matches',
            params: `Invalid ${info.label}`,
          },
          {
            field: 'PasswordOneOf',
            type: 'oneOf',
            params: `${info.label} must match.`,
          },
          {
            field: 'PasswordNotOneOf',
            type: 'notOneOf',
            params: `${info.label} invalid pattern.`,
          },
        ];
        break;
      default:
        validation = 'string';
        if (info.label.includes('Phone')) {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'Phone',
              maxLength: 10,
              type: 'matches',
              params: 'Total number of digits of phone number should be 10',
            },
          ];
        } else if (info.label.includes('Postal')) {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'Postal',
              maxLength: 10,
              type: 'matches',
              params: 'Postal Code is not Valid',
            },
          ];
        } else if (
          info.label.includes('First') ||
          info.label.includes('Last')
        ) {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'Name',
              maxLength: 50,
              type: `matches`,
              params: `Name is not Valid`,
            },
          ];
        } else if (info.label.includes('Address')) {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'Address',
              maxLength: 50,
              type: 'max',
              params: `Text entered exceeds max length of 50`,
            },
          ];
        } else if (info.label === 'City') {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'City',
              maxLength: 30,
              type: 'max',
              params: `${info.label} is not Valid`,
            },
          ];
        } else if (info.label === 'Driver License Number') {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'DriverLicense',
              maxLength: 20,
              type: 'max',
              params: `Text entered exceeds max length of 20`,
            },
          ];
        } else if (info.label === 'Military Commanding Officer') {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'MilitaryCO',
              type: 'max',
              maxLength: 50,
              params: 'Text entered exceeds max length of 50',
            },
          ];
        } else if (info.label === 'Military ID') {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
            {
              field: 'MilitaryID',
              type: 'max',
              maxLength: 20,
              params: 'Text entered exceeds max length of 20',
            },
          ];
        } else {
          validationMessages = [
            info.required && {
              type: 'required',
              params: `${info.label} is Required`,
            },
          ];
        }

        break;
    }

    return {
      name: `${preFix}_${info.label.replace(/[^A-Z0-9]/gi, '')}`,
      label: `${info.label}`,
      type: info.type,
      validationType: validation,
      requiredErrorMsg: validationMessages,
    };
  });
}
export const frameInitialValues = (ob: any, preFix: string) => {
  const toReturn: any = {};
  for (const i in ob) {
    if (!ob.hasOwnProperty(i)) continue;
    if (typeof ob[i] === 'object' && ob[i] !== null) {
      const flatObject = frameInitialValues(ob[i], preFix);
      for (const x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;
        if (x.includes('label')) {
          toReturn[`${preFix}_${flatObject[x].replace(/[^A-Z0-9]/gi, '')}`] =
            '';
        }
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};
export const handleFormValidations = (
  formDataValidations: {
    id: number;
    preFix: string;
    data: any[];
  }[],
  path: string
) => {
  const tenantSearchData = useSectionData();
  const { formInitialValues } = tenantSearchData;
  const formValues: any[] = [];
  const clearFormValues: any[] = [];
  formDataValidations.map(
    form => (formValues[form.id] = frameInitialValues(form.data, form.preFix))
  );
  clearFormValues.push(formValues);
  const initialValue = formInitialValues[0];
  if (initialValue !== undefined) {
    const initialValues = path.includes('reserve')
      ? [initialValue[0]]
      : initialValue;
    formValues.map((formData, index) => {
      const tenant_Data = initialValues[index];
      if (tenant_Data) {
        for (const [key, value] of Object.entries(tenant_Data)) {
          formData[key] = value;
        }
      }
    });
    formValues[0]['TenantInfo_DesiredMoveInDate'] =
      Object.keys(formValues[0]).includes('TenantInfo_DesiredMoveInDate') &&
        path.includes('reserve')
        ? format(new Date(), 'MM/dd/yyyy')
        : '';
    return formValues;
  } else {
    formValues[0]['TenantInfo_DesiredMoveInDate'] =
      Object.keys(formValues[0]).includes('TenantInfo_DesiredMoveInDate') &&
        path.includes('reserve')
        ? format(new Date(), 'MM/dd/yyyy')
        : '';
    return formValues;
  }
};

export const ErrorMessage = ({ handleClick }: any) => {
  const { errorMessageHeading, errorMessagePara } = ErrorMessageInfo;
  return (
    <div className="notification is-danger is-light">
      <button className="delete" onClick={() => handleClick()}></button>
      <h2 className="has-text-bold">{errorMessageHeading}</h2>
      <p className="para">{errorMessagePara}</p>
    </div>
  );
};
